import React, { useCallback,  useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid, Modal, Typography } from "@material-ui/core";
import useStyles from "./RegisterStatus.style";
import { IResendRegisterModel } from "../../models/AuthModel";
import { resendRegisterEmail } from "../../data-services/Auth/AuthService";
import i18n from "../../i18n";
import LoadingSpinner from "../../LoadingSpinner";

const RegisterStatus: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation(["translation"]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  let query = useQuery();

  const resendEmail =  useCallback( async () => {
    try {
      setIsSubmitting(true);
      const resendData: IResendRegisterModel = {
        email: query.get("email"),
        browserLanguage: i18n.language
      };

       await resendRegisterEmail(resendData);

    } catch (error) {
      return { status: "error", message: "Error" };
    }
    finally{
      setIsSubmitting(false);
    }
  }, [query]);

  return (
    <>
      <Modal open={isSubmitting}>
        <div style={{ top: "50%" }}>{isSubmitting && <LoadingSpinner />}</div>
      </Modal>
    <Grid container className={classes.statusWrapper}>
      <Grid item className={classes.itemContainer}>
        <img
          className={classes.image}
          src="/img/Detectortoolportal_height_small.jpg"
          alt="sentRegisterEmail"
        />
      </Grid>
      <Grid item className={classes.contentWrapper}>
        <img src="/img/mailMessage.svg" alt="message" style={{width: "40px"}}/>
        <Typography className={classes.title} component="h3">
          {t("translation:REGISTER_CONFIRMATION.title")}
        </Typography>
        <Typography className={classes.content}>
          {t("translation:REGISTER_CONFIRMATION.content")}
        </Typography>
        <Typography className={classes.link} onClick={resendEmail}>
          {t("translation:REGISTER_CONFIRMATION.linkTitle")}
        </Typography>
      </Grid>
    </Grid>
    </>
  );
};

export default RegisterStatus;
